import { getAll} from "../../fetchs/get";
import { sessionEnd } from "../../redux/actions";

export default async function getTNSData (
    forecastId : string | undefined,
    forecastVersion: number | undefined,
    setTNSData : Function,
    token : string | undefined,
    dispatch : Function,
    setError : Function
) {
    if(token){
        getAll(token, '/forecast/'+forecastId+"/"+forecastVersion+'/tns', setTNSData, 
            () => {
                dispatch(sessionEnd());
            }, setError
        )
    }
}